import React, { ReactElement, useState } from 'react';
import cn from 'classnames';
import './index.scss';
import { ControllerFieldState } from 'react-hook-form';
import { Button, Icon } from 'components';
import { t } from 'i18next';

interface InputProps {
	label?: string;
	labelClass?: 'sm' | 'md' | string;
	placeholder?: string;
	className?: string;
	type?: string;
	inputClasses?: string;
	textareaHeight?: number;
	icon?: string;
	fieldState?: ControllerFieldState;
	[x: string]: any;
}

export const Input = ({
	label,
	className,
	labelClass,
	type,
	inputClasses,
	textareaHeight,
	fieldState,
	icon,
	...field
}: InputProps) => {
	return (
		<div className={cn(className, { relative: icon })}>
			{label && (
				<label
					htmlFor={field.name}
					className={`label ${labelClass}`}
				>
					{label}
				</label>
			)}
			{type === 'file' ? (
				<div>
					<label
						htmlFor={field.name}
						className={cn(
							'input-file cursor-pointer  flex flex-row justify-between items-center',
							{
								'outline outline-2 outline-red': fieldState?.invalid,
							},
							inputClasses
						)}
					>
						<div className='text-grey-text'>{`${
							field.value || 'JPG o PDF max 1MB'
						}`}</div>
						<Button type='div'>+ {t('uploadFile')}</Button>
					</label>
					<input
						type='file'
						id={field.name}
						{...field}
					/>
				</div>
			) : type === 'textarea' ? (
				<textarea
					className={cn(
						{
							'outline outline-2 outline-red': fieldState?.invalid,
						},
						inputClasses
					)}
					rows={4}
					{...field}
				/>
			) : (
				<>
					<input
						type={type}
						className={cn(
							{
								'outline outline-2 outline-red': fieldState?.invalid,
								'pr-10': icon,
							},
							inputClasses
						)}
						{...field}
					/>
					{icon && (
						<Icon
							className='absolute right-3 top-1/2 -translate-y-1/2 '
							name={icon}
						/>
					)}
				</>
			)}
			{fieldState?.error && (
				<div className='mt-2 text-red text-xs capitalize'>
					{fieldState?.error.message}
				</div>
			)}
		</div>
	);
};
